import {FatalError, IncidentalError} from "./Store";

export function SetFatalError() {
    FatalError.set(true);
}

export function SetIncidentalError() {
    IncidentalError.set(true);
}

export function ClearIncidentalError() {
    IncidentalError.set(false);
}
